import React from "react";
import BannerPlayer from "../home/components/BannerPlayer";
// import img from "../../assets/img/about-img.png";
import AboutShape from "./components/AboutShape";
const About = () => {
	return (
		<section className="about-section">
			<div className="container">
				<div className="row g-4">
					<div className="col-lg-6">
						<div className="about-img">
							{/* <img src={img} alt="" /> */}
							<div className="mw-500">
								<BannerPlayer />
							</div>
							<div className="shape">
								<AboutShape />
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="about-content">
							<h2 className="title">About Us</h2>
							<p>
								The fundraising Space is Broken.{" "}
								<span className="d-block"></span> We’ve Come A Long Way,
								But We Can Do Better.
							</p>
							<p>
								Today’s decentralized platforms are slow, confusing,
								expensive, and isolate both new and experienced
								investors. Participation is restricted to a select few
								and technical issues seem to be the norm, rather than
								the exception.
							</p>
							<p>
								Blockchain innovations are accelerating faster every
								day, it’s time for fundraising to catch up.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
